export default abstract class BaseEntity {
    constructor(public id?: number | string) {}

    abstract getEntityLabel(): string;
}
